export default {
  title: 'Tilpas ordre',
  product_info: {
    earn_points: 'Optjen {{points}} point',
  },
};
